import { useRef, useState } from 'react';

/*
  Пасхалка знака в меню: несколько быстрых нажатий подряд — порыв ветра, веер раскручивается
  (KanameMark gust). Каждое следующее быстрое нажатие, пока веер крутится, — ещё один порыв.
*/

/** Сколько нажатий подряд и за какое время считаются «порывом». */
const TAPS = 3;
const WINDOW_MS = 1200;

export function useGust(): { gust: number; tap: () => void } {
  const taps = useRef<number[]>([]);
  const [gust, setGust] = useState(0);
  const tap = () => {
    const now = performance.now();
    taps.current = [...taps.current.filter((t) => now - t < WINDOW_MS), now];
    if (taps.current.length >= TAPS) setGust((g) => g + 1);
  };
  return { gust, tap };
}
